/* eslint-disable func-names */
/* eslint-disable no-param-reassign */
import { createSelector } from 'reselect';

const payWayStore = store => store.user.paywayData;

const groupBy = function(xs, key) {
  return xs.reduce((rv, x) => {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

export const payWaySelector = createSelector(
  payWayStore,
  (data = {}) => {
    const list = data === null ? [] : data;

    const itHasITunes =
      list.findIndex(
        medio => medio?.purchase_data?.gateway === 'itunesgate',
      ) !== -1;

    const filter = list
      ?.filter(f => typeof f?.purchase_data === 'object')
      ?.map(item => ({
        gateway: item?.purchase_data?.gateway,
        offerId: item?.offer_id,
      }));

    const result = groupBy(filter, 'gateway');

    return {
      list,
      groupBy: result,
      gateways: Object.keys(result),
      itHasITunes,
    };
  },
);

export const creditCardPayway = createSelector(
  store => store?.user?.profile?.paymentMethods || [],
  gateways =>
    Boolean(gateways.find(gateway => gateway?.gateway === 'claropagosgate')),
);
